<template>
  <div class='asideContent'>
    <div v-if="!childrens.length" class='index_content s_bf'>
      <div >
        <div class="logoContent">
          <div v-has:balanceAccount="()=> {$router.push('/businessCenter/information/account')}" >
              <a-avatar :src='info.picdomain+"/"+info.overView.brand_logo' :style="{ width: '90px',height:'90px',border:'1px solid #f7f9f8' }" v-if="info.overView.brand_logo">
              </a-avatar>
              <img src='@/assets/images/index/indexHeader.png' alt="" style="width: 90px;height:90px;border:1px solid #f7f9f8;border-radius: 100%;" v-else>
          </div>
          <div class="avatarName mt15 mb15">{{info.overView.brand_name}}</div>
          <div class="icons m-b-15">
            <img src="@/assets/images/index/wechat_active.png" alt="" class='width-34 mr15' v-if="info.overView.app_id">
            <img src="@/assets/images/index/wechat.png" alt="" class='width-34 mr15' v-else>
            <div v-has:qualified="()=> {$router.push('/businessCenter/information/qualified')}" style="display: inline-block;">
              <img src="@/assets/images/index/enterprise_active.png" alt="" class='width-34  mr15' v-if="info.overView.is_certificate">
              <img src="@/assets/images/index/enterprise.png" alt="" class='width-34 mr15' v-else>
            </div>
            <!-- <img src="@/assets/images/index/enterprise_active.png" alt="" class='width-34  mr15' v-if="info.overView.is_certificate">
            <img src="@/assets/images/index/enterprise.png" alt="" class='width-34 mr15' v-else> -->
            <img src="@/assets/images/index/r_active.png" alt="" class='width-34  '>
          </div>
          <ul class='s_flex_bian_c ' style="width:100%">
            <div class='text-ac' v-has:balanceAccount="()=> {$router.push('/businessCenter/balance')}" >
              <div style="font-weight:500">{{info.overView.balance || 0.00}}</div>
              <div>余额</div>
            </div>
            <div @click="handleMenu('/qrcode/batch/index','/qrcode',4)" class="text-ac">
              <div style="font-weight:500">{{CodeNum}}</div>
              <div>码库</div>
            </div>
            <div @click="handleMenu('/messageCenter/sms/smsCenter','/messageCenter',1)" class="text-ac">
              <div style="font-weight:500">{{info.overView.remaining_number || 0}}</div>
              <div>短信</div>
            </div>
          </ul>
        </div>
      </div>
      <div class="line"></div>
      <img src="@/assets/images/index/index_side.png" style="width:320px">
      <!-- <div class='m-t-20 p-l-30 p-r-30'>
        <div class="s_flex_ali m-b-20"><img src="@/assets/images/Shape@2x.png" alt="" class="width-21 m-r-10">商户进阶</div>
        <ul style="min-height:100px;line-height:27px" class="article">
          <li class='s_flex_bian_c'><span>【教程】试用申请</span><span class="s_c8e">2020-06-03</span></li>
          <li class='s_flex_bian_c'><span>【教程】试用申请</span><span class="s_c8e">2020-06-03</span></li>
          <li class='s_flex_bian_c'><span>【教程】试用申请</span><span class="s_c8e">2020-06-03</span></li>
        </ul>
      </div>
      <div class='m-t-20 p-l-30 p-r-30'>
        <div class='s_flex_ali m-b-20'><img src="@/assets/images/gengxin-2@2x.png" alt="" class="width-21 m-r-10">版本更新</div>
        <ul style="min-height:100px;line-height:27px " class="article">
          <li class='s_flex_bian_c'><span>【教程】试用申请</span><span class="s_c8e">2020-06-03</span></li>
          <li class='s_flex_bian_c'><span>【教程】试用申请</span><span class="s_c8e">2020-06-03</span></li>
          <li class='s_flex_bian_c'><span>【教程】试用申请</span><span class="s_c8e">2020-06-03</span></li>
        </ul>
      </div> -->
    </div>
  <div class="s_bf"  v-else style="min-height:100%">
      <a-layout-sider :theme='theme'>
      <slider-menu :menuToggle='menuToggle' :theme='theme' :menu="childrens"></slider-menu>
    </a-layout-sider>
  </div>
  </div>
</template>

<script>
import { computed } from "vue";
import SliderMenu from "./SliderMenu.vue";
import store from "@/store";
import { getMenu } from "@/api/public";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
export default {
  name: "AppAside",
  components: {
    SliderMenu,
  },
  props: {
    menuToggle: {
      required: true,
      type: Boolean,
    },
    childrens: {
      type: Array,
    },
    info: {
      require: true,
      type: Object,
    },
  },
  setup(props) {
    const is_show_index = computed({
      get: () => store.state.user.asideMenu,
      set: (val) => {
        val = val == "/index" ? true : false;
      },
    });
    const CodeNum=computed({
       get: () => {
         var code_num=props.info.overView.code_num
         return code_num
       }
     
    })
    // 跳转
    const handleMenu = async(url,auth_url,app_id) => {
      const hide = message.loading("正在加载中...", 0);
      let auth_item;
      let result = await getMenu({app_id:app_id}).then((res) => res.data).catch((error) => error);
      setTimeout(hide);
      if (iscode(result)) {
        auth_item = result.data.find(v=> v.url == auth_url);
        if (!auth_item) {
          message.error("抱歉未匹配到你对应的权限！");
          return;
        }
        if(auth_item.children&&auth_item.children[0].url == url){
          window.open(url)
          return;
        }
        if(auth_item.children&&auth_item.children[0].children[0].url == url){
          window.open(url)
          return;
        }
        message.error("抱歉未匹配到你对应的权限！");
      }
    }
    return {
      theme: "light",
      is_show_index,
      CodeNum,
      handleMenu
    };
  },
};
</script>
<style lang="less" scoped>
</style>
